'use client';
import { useRouter } from 'next/navigation';

import { searchUrl } from 'src/services/route-utils';
import FilterByInput from 'src/components/FilterByInput';

export default function BlogFilterByInput() {
    const router = useRouter();

    const handleChange = (value: string) => {
        router.push(searchUrl(value, 'blog'));
    };

    return (
        <FilterByInput id="blog_filter" pathname={''} onChange={handleChange} placeholder="Sau caută după denumire" />
    );
}
